import {requests} from "../../utils/helpers/api.services";
import {DASHBOARD_URL} from "../../utils/helpers/api.routes";

export const DashboardService = {
    getAllDashboardData: () => requests.get(DASHBOARD_URL)
}